<script>
    import { _ } from "svelte-i18n";
    import { assets } from "../../stores/assets";
    import AssetModal from "./AssetModal.svelte";

    import Card from "./Card.svelte";

    export let multiple;
    export let value;
    export let filter = null;

    let open = false;

    const handleAssetChosen = () => {
        if (!multiple) {
            return (open = false);
        }
    };

    $: selectedValues = multiple ? value : [value];
    $: selectedAssets = getSelectedAssets(selectedValues, $assets);

    const getSelectedAssets = (values, assets) => {
        if (!assets) return [];
        return values
            .map((value) => assets.find(({ fullPath }) => fullPath === value))
            .filter((it) => it);
    };

    const handleRemove = (path) => {
        if (!value) return null;
        if (typeof value === "string") return (value = "");
        value = value.filter((it) => it !== path);
    };

    const handleAssetClick = () => {
        if (multiple) return;
        open = true;
    };
</script>

<style>
    .rounded-xl {
        max-width: 15em;
    }
</style>

<AssetModal
    bind:value
    bind:opened={open}
    {filter}
    {multiple}
    on:asset={handleAssetChosen} />

<div class="grid p-4 grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-4">
    {#each selectedAssets as asset}
        <div
            class={multiple ? '' : 'cursor-pointer'}
            on:click={handleAssetClick}>
            <Card
                {asset}
                deletable={false}
                on:remove={() => handleRemove(asset.fullPath)} />
        </div>
    {/each}
    {#if multiple || !selectedAssets.length}
        <div
            on:click={() => (open = true)}
            class="cursor-pointer rounded-xl overflow-hidden
            flex flex-col items-center justify-center h-64
            bg-gray-200 border-gray-500 border text-gray-600">
            <h4>{$_('Assets.Add')}</h4>
            <span>{$_('Assets.Choose')}</span>
        </div>
    {/if}
</div>
